<template>
  <a
    href=""
    class="modal-tab-toggle"
    :data-target="loginModal"
    data-tab-content="0"
  >
    <span
      :class="[state ? 'icon-saved' : 'icon-save']"
      @click.prevent="performLike"
    ></span>
  </a>
</template>

<script>
export default {
  name: 'AddToWishlist',

  props: {
    userId: {
      type: String,
      required: true,
    },
    siteId: {
      type: String,
      required: true,
    },
    auction: {
      type: Object,
      required: true,
    },
    auctionId: {
      type: Number,
      required: true,
    },
    lot: {
      type: Object,
      required: true,
    },
    lotGender: {
      type: String,
      required: true,
    },
    lotImage: {
      type: String,
      required: true,
    },
    siteUuid: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      state: false,
      loginModal: '',
    }
  },

  computed: {
    wishlistData () {
      return {
        user_id: this.userId,
        site_id: this.siteId,
        auction_id: this.auctionId,
        auction_slug: this.auction.slug,
        auction_start: this.auction.start,
        auction_end: this.auction.end,
        auction_bidup_interval: this.auction.bidup_interval,
        auction_has_bidup: this.auction.has_bidup,
        auction_title: this.auction.title,
        is_pre_bid_auction: this.auction.is_pre_bid_auction,
        auction_show_hammer_price: this.auction.show_hammer_price,
        lot_id: this.lot.id,
        lot_number: this.lot.number,
        lot_ordinal: this.lot.ordinal,
        lot_title: this.lot.title,
        lot_slug: this.lot.slug,
        lot_short_description: this.lot.short_description,
        lot_dame_line_number: this.lot.dame_line_number,
        lot_gender: this.lotGender,
        lot_date_of_birth: this.lot.date_of_birth,
        lot_image: this.lotImage,
        lot_covering_shire: this.lot.covering_shire,
        current_bids_count: this.lot.current_bids_count,
        current_bidders_count: this.lot.current_bidders_count,
        lot_hammer_price: this.lot.hammer_price,
        lot_shire: this.lot.shire,
        lot_dam_by: this.lot.dam_by,
        lot_opening_price: this.lot.opening_price,
        lot_estimated_price: this.lot.estimated_price,
        site_uuid: this.siteUuid,
        lot_winner_country_id: this.lot.winner_country_id,
        lot_winner_user_id: this.lot.winner_user_id,
        lot_bidups_count: this.lot.bidups_count,
        lot_auction_or_bidup_end_time: this.lot.auction_or_bidup_end_time,
        is_withdrawn: this.lot.is_withdrawn ? 'on' : 'off'
      }
    },
  },

  mounted () {
    if (this.userId) {
      this.init()
    }
  },

  methods: {
    init () {
      let $url = route('user.wishlist.get', {
        userId: this.userId,
        lotId: this.lot.id,
        auctionId: this.auctionId,
        siteId: this.siteId,
      })

      axios
        .get($url)
        .then(response => {
          if (response.data === 1) {
            this.state = true
          }
        })
        .catch(error => {
        })
    },

    performLike () {
      let $url = route('user.wishlist.add')
      if (this.userId) {
        if (this.auction.ended_at) {
          let alertElm = Metro.dialog.create({
            content: `
                <div>
                    <p>${this.$options.filters.trans('javascript.lots.lot_favorite_unavailable_post_auction')}</p>
                </div>
            `,
            closeButton: true,
            onClose: () => {
              alertElm = null
            }
          })
        } else {
          axios
            .post($url, this.wishlistData)
            .then(response => {
              this.state = response.data === 1
            })
            .catch(error => {
            })
        }
      } else {
        this.loginModal = 'login-register'
      }
    },
  },
}
</script>
